import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    getChargeBasisAll,
    deleteChargeBasis,
    updateStatus,
} from "../../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import { useDispatch } from "react-redux";
import Datatable from "../../../ExtraComponents/ReusableTable2";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import axios from "axios";
import * as Config from "../../../Utils/Config";

const AllChargebasis = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const agent_id = JSON.parse(localStorage.getItem("agent_id"));

    const [chargeBasisData, setChargeBasisData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(50);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [InputValue, setInputValue] = useState("");
    const [activetab, setActivetab] = useState("");
    const [initialized, setInitialized] = useState(false);

    const location = useLocation();
    const { state } = location;

    useEffect(() => {
        getChargeBasisData();
    }, [currentPage, pageSize, InputValue, activetab, initialized]);

    useEffect(() => {
        setCurrentPage(1);
    }, [InputValue]);

    const handleTabChange = (event) => {
        setActivetab(event.target.value);
    };
    useEffect(() => {
        if (state) {
            const { chargebasisType, search } = state;

            if (chargebasisType !== undefined) {
                setActivetab(chargebasisType);
            }

            if (search) {
                setInputValue(search);
            }
        }

        setInitialized(true);
    }, [state]);

    useEffect(() => {
        if (loading) {
            Swal.fire({
                title: "",
                html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                background: "transparent",
                backdrop: "rgba(229, 233, 236, 0.2)",
                customClass: {
                    popup: "no-shadow",
                },
            });
        } else {
            Swal.close();
        }
    }, [loading]);

    const getChargeBasisData = async () => {
        const req = {
            agent_id: agent_id,
            page: currentPage,
            limit: pageSize,
            search: InputValue,
            status: activetab,
        };

        await dispatch(getChargeBasisAll(req))
            .unwrap()
            .then((response) => {
                setLoading(false);
                if (response.status) {
                    setChargeBasisData(response.data);
                    setTotalRecords(response?.pagination?.total || 0);

                } else {
                    setChargeBasisData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching charge basis data:", error);
                setLoading(false);
            });
    };

    const handleEdit = (row) => {
        navigate("/admin/pricing/edit-charge-basis", { state: { data: row } });
    };

    const handleDelete = (row) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ff00aa",
            cancelButtonColor: "#616161",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteChargeBasis({ id: row.id, agent_id: agent_id }))
                    .then((response) => {
                        if (response.payload.status) {
                            Swal.fire("Deleted!", response.payload.msg, "success");
                            getChargeBasisData();
                        } else {
                            Swal.fire("Error!", response.payload.msg, "error");
                        }
                    })
                    .catch((error) => {
                        console.error("Error deleting charge basis:", error);
                    });
            }
        });
    };

    const handleChangeStatus = (row, e, status) => {
        e.preventDefault();
        Swal.fire({
            title: "Are you sure?",
            text: "You want to change the status?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ff00aa",
            cancelButtonColor: "#616161",
            confirmButtonText: "Yes, change it!",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(
                    updateStatus({
                        id: row.id,
                        status: status ? "1" : "0",
                        agent_id: agent_id,
                    }),
                )
                    .unwrap()
                    .then((response) => {
                        if (response.status) {
                            getChargeBasisData();
                            Swal.fire("Changed!", "Your status has been changed.", "success");
                        }
                    })
                    .catch((error) => {
                        console.error("Error updating charge basis:", error);
                    });
            } else {
                e.target.checked = !status;
                getChargeBasisData();
            }
        });
    };

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected + 1);
    };

    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(1);
    };

    const handleExport = async () => {
        let totalData = chargeBasisData;
        const req = {
            agent_id: agent_id,
            page: 1,
            limit: 0,
            search: InputValue,
        };

        setLoading(true);
        await dispatch(getChargeBasisAll(req))
            .unwrap()
            .then((response) => {
                if (response.status) {
                    totalData = response.data;
                } else {
                    setLoading(false);
                    Swal.fire({
                        icon: "warning",
                        title: "No Data",
                        text: "No data to export!",
                    });
                    return;
                }
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire({
                    icon: "warning",
                    title: "No Data",
                    text: "No data to export!",
                });
                return;
            });

        if (totalData.length === 0) {
            setLoading(false);
            Swal.fire({
                icon: "warning",
                title: "No Data",
                text: "No data to export!",
            });
            return;
        }

        const exportData = totalData?.map((row) => ({
            "Charge Basis Name": row.name,
            Type: (row.self_assessment === "1" && row.basistypes_id === 1)? "Per Unit & Self Assessment" : row.BasisType?.name || "-",
            Status: row.status === "1" ? "Active" : "Inactive",
        }));

        downloadCSV(exportData, "Charge Basis Details.csv");
        setLoading(false);
    };

    const downloadCSV = (data, filename) => {
        const csvRows = [];
        const headers = Object.keys(data[0]);
        csvRows.push(headers.join(","));
        data.forEach((row) => {
            const values = headers.map((h) => `"${row[h] || ""}"`);
            csvRows.push(values.join(","));
        });
        const csvString = csvRows.join("\n");
        const blob = new Blob([csvString], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", filename);
        a.click();
    };

    const handleExportPDF = async () => {
        setLoading(true);
        let totalData = chargeBasisData;
        const req = {
            agent_id: agent_id,
            page: 1,
            limit: 0,
            search: InputValue,
        };

        await dispatch(getChargeBasisAll(req))
            .unwrap()
            .then((response) => {
                if (response.status) {
                    totalData = response.data;
                } else {
                    setLoading(false);
                    Swal.fire({
                        icon: "warning",
                        title: "No Data",
                        text: "No data to export!",
                    });
                    return;
                }
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire({
                    icon: "warning",
                    title: "No Data",
                    text: "No data to export!",
                });
                return;
            });

        if (totalData.length === 0) {
            setLoading(false);
            Swal.fire({
                icon: "warning",
                title: "No Data",
                text: "No data to export!",
            });
            return;
        }

        const formattedData = totalData?.map((row, index) => ({
            s_no: index + 1,
            name: row.name,
            type: (row.self_assessment === "1" && row.basistypes_id === 1)? "Per Unit & Self Assessment" : row.BasisType?.name || "-",
            status: row.status === "1" ? "Active" : "Inactive",
        }));

        const columns = [
            { label: "S.No", key: "s_no" },
            { label: "Charge Basis Name", key: "name" },
            { label: "Type", key: "type" },
            { label: "Status", key: "status" },
        ];

        try {
            const res = await axios.post(
                Config.base_url + "export-contract-pdf",
                { data: formattedData, columns: columns, title: "Charge Basis List" },
                { responseType: "blob" },
            );
            setLoading(false);
            const blob = new Blob([res.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Charge_Basis_Details.pdf";
            a.click();
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Export Failed",
                text: "Error exporting PDF",
            });
        }
    };

    const columns = [
        {
            name: "Charge Basis Name",
            cell: (row) => (
                <a
                    href={`#/admin/pricing/view-chargebasis?id=${row.id}&status=${row?.deleted}`}
                    className="text-pink font-bold"
                    style={{
                        fontWeight: "bold",
                    }}
                    onClick={(e) => {
                        if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
                            e.preventDefault();
                            navigate("/admin/pricing/view-chargebasis", {
                                state: { data: row },
                            });
                        }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {row.name}
                </a>
            ),
            selector: (row) => row.name,
            sortable: true,
            width: "40%",
        },
        // {
        //   name: "Charge Basis Name",
        //   selector: (row) => row.name,
        //   sortable: true,
        //   width: "40%",
        // },
        {
            name: "Type",
            cell: (row) => row.BasisType?.name || "-",
            selector: (row) => row.BasisType?.name,
            sortable: true,
            width: "40%",
        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="w-100 d-flex align-items-center">
                    <button
                        className="btn fs-4 py-0 px-2"
                        onClick={() => handleEdit(row)}
                    >
                        <i className="ri-edit-line"></i>
                    </button>
                    {row.deleted && (
                        <>
                            <div className="form-switch px-1">
                                <input
                                    className="form-check-input ms-0 mt-0"
                                    type="checkbox"
                                    id={`statusToggle-${row.id}`}
                                    checked={row.status === "1"}
                                    onClick={(e) => handleChangeStatus(row, e, e.target.checked)}
                                />
                            </div>
                            <button
                                className="btn fs-4 py-0 px-0"
                                onClick={() => handleDelete(row)}
                            >
                                <i className="bx bx-trash"></i>
                            </button>
                        </>
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: "20%",
            className: "text-center",
        },
    ];

     const showPagination  = pageSize !== 0 && Math.ceil(totalRecords / pageSize)

    return (
        <div>
            <div className="row mb-3">
                <div className="col">
                    <h4 className="page-title">  <button
                        className="btn p-0 fs-5"
                        onClick={() => navigate("/admin/pricing/all-charge-basis")}
                    >
                        <i className="bx bx-arrow-back text-pink pe-1"></i>
                    </button>Charge Basis</h4>
                </div>
                <div className="col-auto align-self-center">
                    {chargeBasisData?.length > 0 && (
                        <>
                            <button
                                className="btn-outline-pink btn me-2"
                                onClick={handleExportPDF}
                            >
                                <i className="ri-download-2-line"></i> Export PDF
                            </button>
                            <button
                                className="btn-outline-pink btn me-2"
                                onClick={handleExport}
                            >
                                <i className="ri-download-2-line"></i> Export CSV
                            </button>
                        </>
                    )}
                </div>
            </div>

            <section className="section dashboard">
                <div className="row">
                    <data className="col-lg-3 datatable-search mb-2">
                        <input
                            type="text"
                            className="search p-2 icon"
                            placeholder="Search here"
                            value={InputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                        />
                    </data>

                    <div className="col-lg-3 filter-select mb-3 select_tab">
                        <select
                            className="form-select"
                            value={activetab}
                            onChange={handleTabChange}
                        >
                            <option value="">All</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                    </div>
                </div>




                <div className="table-main-div">
                    <Datatable
                        className="mb-2"
                        columns={columns}
                        data={chargeBasisData}
                        filter={true}
                    />

                    {chargeBasisData.length > 0 ? (
                        <div>

                            {
                                showPagination > 1 && (
                                    <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={
                                    pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)
                                }
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageChange}
                                containerClassName={"pagination"}
                                activeClassName={"active"}
                            />
                                )
                            }
                            

                            <div className="mt-0">
                                <select
                                    // className="perpage-select"
                                    className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                                    value={pageSize}
                                    onChange={handlePageSizeChange}
                                >
                                    {/* <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option> */}
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                    <option value={0}>{"ALL"}</option>
                                </select>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </section>
        </div>
    );
};

export default AllChargebasis;
